import Container from 'elements/Container'
import React from 'react'
import { useParams, useHistory } from 'react-router'
import { TEAMS } from './teams'
import { ReactComponent as ArrowBack } from 'assets/svg/icons/filled/arrow-back.svg'
import {
  ProfileImgWrapper,
  ProfileName,
  ProfileRole,
  TRow,
  ProfileIgn,
  QuoteWrap,
  ResponsiveFlex,
  ProfileWrapper,
  ProfileNameWrap,
  HoverEffect,
  Backer,
  ProfileImg,
  RoleBoxProfileWrapper,
  NameWrapperDesktop,
  NameWrapperMobile,
  QuoteWrapper
} from './styled'
import { ReactComponent as QuoteSvg } from 'assets/svg/quotes.svg'
import { ReactComponent as User } from 'assets/svg/icons/socials/user.svg'
import { ReactComponent as TriangleBg } from 'assets/svg/triangleBg.svg'
import { ReactComponent as CcRoleBox } from 'assets/svg/rolebox/content_creator.svg'
import { ReactComponent as EngineerRoleBox } from 'assets/svg/rolebox/engineer.svg'

import Profilesocials from './ProfileSocials'
import { TAB } from './tab.enum'
import Skeleton from 'components/Skeleton'
import useProgressiveImg from 'hooks/useProgressiveImg'
import toSlug from 'utils/toSlug'

const Profilepage = () => {
  const { ign } = useParams<{ ign: string }>()
  const history = useHistory()

  const profile = TEAMS.filter(team => toSlug(team.nameShort) === toSlug(ign))[0]
  const img = profile !== undefined ? profile.img4x : ''
  const [{ loading: loadingImg, hQsrc }] = useProgressiveImg('LOADING', img)

  return profile !== undefined ? (
    <Container>
      <Backer onClick={() => history.push('/team')} className="backer">
        <ArrowBack style={{ cursor: 'pointer', marginRight: '12px' }} height="36" width="36" />
        <HoverEffect>BACK</HoverEffect>
      </Backer>
      <ResponsiveFlex style={{ width: '100%' }}>
        <NameWrapperMobile>
          <ProfileName>
            <ProfileNameWrap>
              <User height="20" width="20" style={{ marginRight: '4px' }} />
              <div>{profile.nameLong}</div>
            </ProfileNameWrap>
          </ProfileName>
          <ProfileIgn>{profile.ign}</ProfileIgn>
        </NameWrapperMobile>
        <ProfileImgWrapper>
          <div>
            {loadingImg ? (
              <div style={{ display: 'flex', justifyContent: 'center' }}>
                <Skeleton height="38em" width="80%" />
              </div>
            ) : (
              <>
                <div style={{ width: '100%', display: 'flex', justifyContent: 'center', position: 'relative' }}>
                  <TriangleBg
                    style={{
                      position: 'absolute',
                      zIndex: -1,
                      top: '36px',
                      maxWidth: '26em',
                      width: '90%',
                      height: 'auto'
                    }}
                  />
                </div>
                <ProfileImg src={hQsrc} loading="lazy" height="100%" alt="person" />
                <RoleBoxProfileWrapper>
                  {profile.position === TAB.ENGINEERS && <EngineerRoleBox />}
                  {profile.position === TAB.CONTENT_CREATORS && <CcRoleBox />}
                  {profile.position === TAB.STREAMERS && <CcRoleBox />}
                </RoleBoxProfileWrapper>
              </>
            )}
          </div>
        </ProfileImgWrapper>
        <ProfileWrapper>
          <NameWrapperDesktop>
            <ProfileName>
              <ProfileNameWrap>
                <User height="20" width="20" style={{ marginRight: '4px' }} />
                <div>{profile.nameLong}</div>
              </ProfileNameWrap>
            </ProfileName>
            <ProfileIgn>{profile.ign}</ProfileIgn>
            {/* <ProfileRole>{profile.role}</ProfileRole> */}
          </NameWrapperDesktop>
          <QuoteWrapper>
            <QuoteWrap>
              <QuoteSvg
                style={{
                  position: 'absolute',
                  right: 12,
                  top: -10
                }}
              />
              {profile.description}
            </QuoteWrap>
          </QuoteWrapper>
          <table style={{ marginTop: '32px' }}>
            <tbody>
              <TRow>
                <td>Joined</td>
                <td>:</td>
                <td>{profile.joinedDate}</td>
              </TRow>
              <TRow>
                <td style={{ verticalAlign: 'top' }}>Games</td>
                <td style={{ verticalAlign: 'top' }}>:</td>
                <td style={{ verticalAlign: 'top' }}>{profile.games}</td>
              </TRow>
            </tbody>
          </table>
          {/* <div
            style={{
              // background: 'red',
              // clear: 'both',
              // float: 'left'
              display: 'inline-block',
              background: 'red'
            }}
          >
            asd
          </div> */}

          <div
            style={{
              paddingTop: '20px'
            }}
          >
            <Profilesocials Socials={profile.socmed} />
          </div>
        </ProfileWrapper>
      </ResponsiveFlex>
    </Container>
  ) : (
    <></>
  )
}

export default Profilepage
